import { headers } from "./ApiHelpers";

// Enum to map feature flags to valid strings the API accepts to represent them
export enum ClassroomFeatureFlagRequest {
  ScreenShare = "SCREEN_SHARE",
  SchoolAssociations = "SCHOOL_ASSOCIATIONS",
  UsernamePasswordLogin = "USERNAME_PASSWORD_LOGIN",
}

// Enum of all feature flags the API could respond with
export enum ClassroomFeatureFlagResponse {
  ScreenShare = "SCREEN_SHARE",
  SchoolAssociations = "SCHOOL_ASSOCIATIONS",
  ScheduledClassesV2 = "SCHEDULED_CLASSES_V2",
  UsernamePasswordLogin = "USERNAME_PASSWORD_LOGIN",
}

/**
 * Fetches classroom feature flag configuration.
 */
export function getClassroomFeatureFlags(): Promise<Response> {
  return fetch(`/api/classrooms/enabled-features`, {
    method: "GET",
    headers: headers(),
  });
}

export interface ClassroomFeatureFlagsResponseShape {
  applianceId: string;
  enabledFeatures: ClassroomFeatureFlagResponse[];
}

/**
 * Saves classroom feature flag configuration.
 *
 * 200 - Created or updated successfully
 * 400 - Request validation failed
 */
export function updateClassroomFeatureFlags(features: ClassroomFeatureFlagRequest[]): Promise<Response> {
  return fetch(`/api/classrooms/enabled-features`, {
    method: "PUT",
    headers: headers(),
    body: JSON.stringify({ enabledFeatures: features } satisfies UpdateClassroomFeatureFlagsPayloadShape),
  });
}

export interface UpdateClassroomFeatureFlagsPayloadShape {
  enabledFeatures: ClassroomFeatureFlagRequest[];
}
